import React from 'react'
import Loader from '../../Icons/Loader'


function LoadingView() {
   return <Loader height={70} width={70} />
}

export default LoadingView
